import _find from "lodash/find";
import React from 'react';
import { StaticQuery } from 'gatsby';
import { FormattedMessage } from 'react-intl';
import { findT } from '../../_helpers';
import PhoneNumber from '../../text/PhoneNumber/PhoneNumber';
import Link from '../../elements/Link/Link';
import { jsx as ___EmotionJSX } from "@emotion/react";
const ContactWidget = props => {
  const translations = findT(props.widget.translations, props.lang);
  return ___EmotionJSX(StaticQuery, {
    query: query,
    render: data => {
      const {
        emails,
        numbers
      } = data.directusCompany;
      const email = _find(emails, email => email.primary).email;
      const phoneNumber = _find(numbers, number => number.type === 'phone' && number.primary);
      const mobileNumber = _find(numbers, number => number.type === 'mobile' && number.primary);
      return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("h4", null, translations.header ? translations.header : ___EmotionJSX(FormattedMessage, {
        id: "components.widgets.contactWidget.defaultHeader",
        tagName: "span"
      })), ___EmotionJSX("ul", null, phoneNumber && ___EmotionJSX("li", null, ___EmotionJSX(FormattedMessage, {
        id: "components.widgets.addressWidget.tel",
        tagName: "span"
      }), " ", ___EmotionJSX(PhoneNumber, {
        number: phoneNumber.number
      })), mobileNumber && ___EmotionJSX("li", null, ___EmotionJSX(FormattedMessage, {
        id: "components.widgets.addressWidget.mobile",
        tagName: "span"
      }), " ", ___EmotionJSX(PhoneNumber, {
        number: mobileNumber.number
      })), email && ___EmotionJSX("li", null, ___EmotionJSX(FormattedMessage, {
        id: "components.widgets.addressWidget.email",
        tagName: "span"
      }), " ", ___EmotionJSX(Link, {
        external: true,
        to: `mailto:${email}`,
        title: "Email"
      }, email))));
    }
  });
};
const query = "1128902974";
export default ContactWidget;